<template>
  <div v-if="publicHolidayCard.show" class="card public-holiday-card align-items-center justify-content-space-between border-color-green my-4">
    <div class="card-body d-flex">
      <div class="col-bank mx-3">
        <img :src="require('@/assets/img/icon/public-holiday-icon.png')" />
      </div>
      <div class="col-details">
        <p class="bold m-0 wandr-level-3">{{$t('alert-public-holiday')}}</p>
        <span class="fs-10">{{$t('public-holiday-info', {countryName:homeCountryName})}}</span>
      </div>
    </div>

    <div class="card-bottom">
      <div class="d-flex" v-for="item in publicHolidayCard.list" :key="item.publicHolidayId">
        <div class="col-country mx-3">
          <img :src="getCircleSmallFlagImg(item.countryId)"/>
        </div>
        <div class="col-details">
          <span class="fs-12">{{item.name}} ({{item.displayDate}})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      homeCountryId:{ required: false },
      homeCountryName:{ required: false }
    },
    mounted(){
      this.getPublicHoliday(this.$store.state.transaction.homeCountryId)
    },
    data: function () {
      return {
        publicHolidayCard : { show: false, list: [] },
      }
    },
    methods: {
      getPublicHoliday(countryId){
        const self = this
        const moment= require('moment')
        const ph = self.$api.staticData.getPublicHoliday(countryId)
        ph.then(function(result) {
          if (result != null && result.length > 0) {
            result.forEach(function(item) {
              if (item.startDate == item.endDate) {
                item.displayDate = moment(item.startDate, 'YYYY-MM-DD').format('MMM DD, Y')
              } else {
                item.displayDate = moment(item.startDate, 'YYYY-MM-DD').format('MMM DD, Y') + ' to ' + moment(item.endDate, 'YYYY-MM-DD').format('MMM DD, Y')
              }
            })
            self.publicHolidayCard.show = true
            self.publicHolidayCard.list = result
          }else{
            self.publicHolidayCard.show = false
            self.publicHolidayCard.list = []
          }
        })
      },
      setHomeCountryId: function(value) {
        this.getPublicHoliday(value)
      }
    },
    created: function() {
      this.$parent.$on('getPublicHolidayOnChange', this.setHomeCountryId)
    }
  }
</script>